function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0 0.02L27.583 0.02 27.583 16.194 0 16.194z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3E48A6",
  fillRule: "nonzero",
  stroke: "#3E48A6",
  d: "M30.869 2.56L13.796 9.656l-4.204 4.236L2.5 31.072l.022 5.968 7.134 17.164 4.236 4.204 17.18 7.092 5.968-.022 17.164-7.134 4.204-4.236 7.092-17.18-.022-5.968-7.134-17.164-4.236-4.204-17.066-7.07c-.096-.04-.212-.02-6.173.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EBECF9",
  fillRule: "nonzero",
  d: "M4 31.269L10.855 14.718 14.718 10.855 31.269 4 36.731 4 53.282 10.855 57.145 14.718 64 31.269 64 36.731 57.145 53.282 53.282 57.145 36.731 64 31.269 64 14.718 57.145 10.855 53.282 4 36.731z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.2 22.8) translate(0 13.656)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3E48A6",
  d: "M13.795 16.193H1.048c-.867 0-1.102-.176-1.038-1.03.175-2.362.395-4.72.625-7.078.088-.912.226-1.821.384-2.724.19-1.083.79-1.928 1.63-2.616C4.51 1.22 6.726.55 9.02.054c.504-.11.809.04 1.076.494.827 1.413 2.03 2.28 3.72 2.268 1.669-.012 2.839-.907 3.66-2.28.26-.438.539-.59 1.02-.484 2.388.52 4.69 1.222 6.596 2.86.82.706 1.35 1.583 1.477 2.64.358 2.997.664 6.002.99 9.003.007.057.012.115.014.172.058 1.311-.09 1.468-1.375 1.467H13.795z",
  mask: "url(#prefix__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M26.308 14.968c0-.196.009-.29-.001-.383-.29-2.737-.596-5.472-.868-8.21-.132-1.336-.771-2.306-1.877-3.047-1.456-.975-3.068-1.525-4.76-1.88-.143-.031-.361.105-.49.223-.542.5-1.015 1.09-1.604 1.525-1.166.858-2.518 1.07-3.926.815-1.502-.272-2.629-1.144-3.54-2.339-.107-.14-.392-.255-.557-.219-.669.15-1.326.352-1.98.554-1.272.393-2.433 1.01-3.43 1.886-.615.54-1.007 1.25-1.102 2.08-.31 2.735-.612 5.47-.904 8.206-.084.783-.063.787.7.787l23.372.002h.967z",
  mask: "url(#prefix__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#3E48A6",
  strokeWidth: 1.36,
  d: "M20.389 6.665c0 3.643-2.954 6.597-6.597 6.597-3.644 0-6.597-2.954-6.597-6.597 0-3.643 2.953-6.597 6.597-6.597 3.643 0 6.597 2.954 6.597 6.597z",
  transform: "translate(13.2 22.8)"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "#3E48A6",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3E48A6",
  d: "M17.688 15.916H2.311C1.037 15.916 0 14.872 0 13.588V4.147c0-1.284 1.037-2.328 2.311-2.328H5.45l.275-.934C5.836.375 6.299 0 6.844 0h6.312c.53 0 .998.373 1.122.89l.008.032.25.897h3.153C18.963 1.819 20 2.863 20 4.147v9.44c0 1.285-1.037 2.329-2.312 2.329z",
  transform: "translate(37.2 15.6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2.159 2.446c-.866 0-1.57.71-1.57 1.582v9.622c0 .872.704 1.581 1.57 1.581H17.83c.866 0 1.57-.71 1.57-1.581V4.028c0-.872-.704-1.582-1.57-1.582h-3.807l-.43-1.544c-.04-.18-.2-.31-.383-.31H6.778c-.185 0-.342.128-.382.31l-.454 1.544H2.159z",
  transform: "translate(37.2 15.6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E48A6",
  d: "M9.962 13.557c-2.684 0-4.867-2.199-4.867-4.9 0-2.703 2.183-4.901 4.867-4.901s4.867 2.198 4.867 4.9c0 2.702-2.183 4.9-4.867 4.9z",
  transform: "translate(37.2 15.6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.962 4.397c-2.333 0-4.23 1.91-4.23 4.26 0 2.348 1.898 4.258 4.23 4.258 2.333 0 4.23-1.91 4.23-4.259s-1.898-4.26-4.23-4.26z",
  transform: "translate(37.2 15.6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E48A6",
  d: "M17.191 4.035c-.393 0-.71.32-.71.716 0 .395.317.716.71.716.393 0 .71-.321.71-.716 0-.395-.318-.716-.71-.716z",
  transform: "translate(37.2 15.6)"
})));

function SvgCsr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsr);
export default __webpack_public_path__ + "static/media/csr.09873755.svg";
export { ForwardRef as ReactComponent };